import React, { useEffect, useState } from 'react'
import { Grid, Stack } from '@mui/material'
import PropTypes from 'prop-types'
import RefJobAction from '../../../../../domain/job/RefJobAction'
import JobAction from '../../../../../import/actions/JobAction'
import { orderBy } from 'lodash'
import { nbPerPageLabelShorty } from '../../../../../referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { getFullDate } from '../../../../../utils/DateUtil'
import loading from 'assets/pictures/loading.gif'
import AppStore from '../../../../../store/AppStore'
import PiezometryAction from '../../../../actions/PiezometryAction'
import DtoJobLogLight from 'import/dto/DtoJobLogLight'
import ErrorIcon from '@mui/icons-material/Error'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { NewTable } from 'components/datatable/NewTable'

const automaticCallLogs = (station, changeStation, setLogs) => {
    RefJobAction.promiseJobExecutions(station.job.id, 10).then(res => {
        JobAction.requestJobLogs(station.job.id, station.jobExecutionId).then(res2 => {
            const jobLogs = res2.data.map(el => new DtoJobLogLight(el, station.jobExecutionId))
            const jobExecution = res.find(e => e.id === station.jobExecutionId)
            changeStation({ jobExecution })
            setLogs(jobLogs.map(l => ({
                ...l,
                color: l.status === 'success' ? 'green-200' : (l.status === 'error' ? 'red-200' : (l.status === 'warning' ? 'yellow-200' : null)),
                date: getFullDate(l.date),
            })))
            if (jobExecution?.statusCode === undefined) {
                setTimeout(() => automaticCallLogs(station, changeStation, setLogs), 2000)
            } else if ([1, 2].includes(jobExecution?.statusCode)) {
                const ids = (jobLogs.find(l => l.status === 'station_ids').value || '').split(',').map(s => parseInt(s))
                AppStore.dispatch(PiezometryAction.fetchPiezometersListSpecific(() => changeStation({ jobExecution, ids })))
            }
        })
    })
}

const AddPiezoStepExecution = ({
    station,
    changeStation,
}) => {
    const [logs, setLogs] = useState([])

    useEffect(() => {
        automaticCallLogs(station, changeStation, setLogs)
    }, [])

    return (
        <Grid paddingTop={2} spacing={2} justifyContent='center' alignItems='center'>
            {
                (() => {
                    switch (station.jobExecution?.statusCode) {
                        case 0:
                            return (
                                <Stack justifyContent='center' alignItems='center' spacing={2} padding={2}>
                                    <h4>{i18n.jobFailedMessage}</h4>
                                    <h5>{i18n.jobFailedDescription}</h5>
                                    <ErrorIcon style={{ color: 'red', fontSize: 40 }} />
                                </Stack>
                            )
                        case 1:
                        case 2:
                            return (
                                <Stack justifyContent='center' alignItems='center' spacing={2} padding={2}>
                                    <h4>{i18n.jobSuccessMessage}</h4>
                                    <h5>{i18n.jobSuccessDescription}</h5>
                                    <CheckCircleIcon style={{ color: 'green', fontSize: 40 }} />
                                </Stack>
                            )
                        case undefined:
                            return (
                                <Stack justifyContent='center' alignItems='center' spacing={2} padding={2}>
                                    <h4>{i18n.jobProgressMessage}</h4>
                                    <h5>{i18n.jobProgressDescription}</h5>
                                    <img src={ loading } />
                                </Stack>
                            )
                        default:
                            return (
                                <Stack justifyContent='center' alignItems='center' spacing={2} padding={2}>
                                    <h4>{i18n.jobUnexpectedMessage}</h4>
                                    <h5>{i18n.jobUnexpectedDescription}</h5>
                                    <ErrorIcon style={{ color: 'red', fontSize: 40 }} />
                                </Stack>
                            )
                    }
                })()
            }
            <Grid size={12}>
                <NewTable
                    maxHeight='62vh'
                    headers={[{ key: 'station', value: i18n.elementLabel }, 'date', 'value', 'status']}
                    rows={orderBy(logs, 'id', 'desc')}
                    inverseDisplay
                    rowsPerPageOptions={nbPerPageLabelShorty}
                />
            </Grid>
        </Grid>
    )
}

AddPiezoStepExecution.propTypes = {
    station: PropTypes.object,
    changeStation: PropTypes.func,
}

export default AddPiezoStepExecution